import React, { useEffect } from 'react';
import { MainTable } from '../../../Components/Macro/MainTable/MainTable';
import { usePostCat } from './PostCatStore';
import Add from './Add';
import Edit from './Edit';

function PostCat() {
    let { cats, columns, setCats, delCat, setEd } = usePostCat()
    useEffect(() => {
        setCats()
    }, [])
    return (
        <>
            <MainTable
                pageTitle={"Post Kategoriyalari"}
                pcolumns={columns}
                pdata={cats}
                setCats={setCats}
                defkey={'id'}
                delCat={delCat}
                setEd={setEd}
                add={<Add />}
                edit={<Edit />}
                onEdit={(data) => {
                    setEd(data)
                }}

                onDelete={(_, id) => {
                    delCat(id.id)
                }}
            />

        </>
    );
}

export default PostCat;